export default "__VITE_ASSET__DmrFreHF__"